/* eslint-disable import/prefer-default-export */
import * as queryString from 'query-string'

/**
 * Detect current browser is weixin browser
 *
 * @returns {Boolean}
 */
export function isWeixinBrowser() {
  return /micromessenger/i.test(navigator.userAgent)
}

/**
 * Get `salesChannelId` from `location.search.sid`
 *
 * @returns {String} return salesChannelId or empty string
 */
export function getSalesChannelId() {
  return parseInt(queryString.parse(location.search).sid, 10)
}



// WEBPACK FOOTER //
// ./client/utils/index.js